import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { Tabs, TabsList, TabsTrigger } from 'components/ui/tabs';

export const ORGANIZATION_ADMIN_PROGRESS_ROUTE = '/organization/admin';
export const ORGANIZATION_ADMIN_RESPONSE_DATA_ROUTE = '/organization/admin/response-data';

type OrganizationAdminTab = 'progress' | 'response-data';

interface OrganizationAdminTabsProps {
  activeTab: OrganizationAdminTab;
}

const tabs = [
  {
    id: 'progress',
    label: 'Progress',
    to: ORGANIZATION_ADMIN_PROGRESS_ROUTE,
  },
  {
    id: 'response-data',
    label: 'Responses',
    to: ORGANIZATION_ADMIN_RESPONSE_DATA_ROUTE,
  },
] as const;

export const OrganizationAdminTabs: React.FC<OrganizationAdminTabsProps> = ({ activeTab }) => {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <Tabs
      value={activeTab}
      className="w-full"
      onValueChange={(value) => {
        const selectedTab = tabs.find((tab) => tab.id === value);
        if (selectedTab) {
          navigate(`${selectedTab.to}${location.search}`);
        }
      }}
    >
      <TabsList aria-label="My Organization sections">
        {tabs.map((tab) => {
          const isActive = tab.id === activeTab;
          return (
            <TabsTrigger
              key={tab.id}
              value={tab.id}
              aria-current={isActive ? 'page' : undefined}
              className="rounded-full border-0 px-5 py-2.5 data-[state=active]:bg-foundation-calm-blue-50 data-[state=active]:shadow-sm"
            >
              {tab.label}
            </TabsTrigger>
          );
        })}
      </TabsList>
    </Tabs>
  );
};
